export const CREATE_EVENT = 'EVENT/CREATE';
export const UPDATE_EVENT = 'EVENT/UPDATE';
export const LOAD_EVENTS = 'EVENTS/LOAD';
export const DELETE_EVENT = 'EVENT/DELETE';
export const LOADING_STATUS = 'EVENT/LOADING_STATUS';
